import React from 'react';

const ModalComprobante = ({
  show,
  onClose,
  comprobante
}) => {
  if (!show || !comprobante) return null;

  const { numero, imagen_base64, fecha_confirmacion, monto } = comprobante;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '500px', borderRadius: '16px', overflow: 'hidden' }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>🧾</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              Comprobante de Pago
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          {/* Información del comprobante */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem',
            marginBottom: '1.5rem'
          }}>
            <div style={{
              padding: '1rem',
              backgroundColor: '#f0fdf4',
              borderRadius: '8px',
              border: '1px solid #bbf7d0'
            }}>
              <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem', color: '#15803d' }}>
                Número de Comprobante
              </p>
              <p style={{ margin: 0, fontWeight: '700', fontSize: '1.1rem', color: '#166534' }}>
                {numero}
              </p>
            </div>

            {monto && (
              <div style={{
                padding: '1rem',
                backgroundColor: '#f0fdf4',
                borderRadius: '8px',
                border: '1px solid #bbf7d0'
              }}>
                <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem', color: '#15803d' }}>
                  Monto
                </p>
                <p style={{ margin: 0, fontWeight: '700', fontSize: '1.1rem', color: '#166534' }}>
                  ${monto}
                </p>
              </div>
            )}

            {fecha_confirmacion && (
              <div style={{
                padding: '1rem',
                backgroundColor: '#f0fdf4',
                borderRadius: '8px',
                border: '1px solid #bbf7d0'
              }}>
                <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem', color: '#15803d' }}>
                  Fecha de Confirmación
                </p>
                <p style={{ margin: 0, fontWeight: '600', color: '#166534' }}>
                  {new Date(fecha_confirmacion).toLocaleDateString('es-ES')}
                </p>
              </div>
            )}
          </div>

          {/* Imagen del comprobante */}
          {imagen_base64 && (
            <div style={{
              marginBottom: '1.5rem',
              borderRadius: '8px',
              overflow: 'hidden',
              border: '2px solid #e5e7eb'
            }}>
              <img
                src={`data:image/jpeg;base64,${imagen_base64}`}
                alt="Comprobante"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }}
              />
            </div>
          )}

          {/* Nota */}
          <div style={{
            padding: '0.75rem 1rem',
            backgroundColor: '#f3f4f6',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            borderLeft: '4px solid #10b981'
          }}>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#6b7280' }}>
              ✓ Comprobante verificado y confirmado
            </p>
          </div>

          <div className="modal-footer">
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{
                width: '100%',
                backgroundColor: '#10b981'
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalComprobante;
